// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"2bebde2c","394":"5bb2ea35","546":"543e4c1d","979":"8d20e220"}[chunkId] + ".chunk.css";
};